import { axiosInstanceWithCredentials } from "./base";

export function getMedals(params) {
    return axiosInstanceWithCredentials.get("/medals", {
        params
    });
}
export function addMedal(data) {
    return axiosInstanceWithCredentials.post("/medal/", data)
}

export function deleteMedal(id) {
    return axiosInstanceWithCredentials.delete(`/medal/${id}`)
}
